export enum StatusIconType {
  ReturningToDock = "ReturningToDock",
  ReturningToLaunch = "ReturningToLaunch",
  ReturningToSafePoint = "ReturningToSafePoint",
  ReturningToPoint = "ReturningToPoint",
  Landing = "Landing",
  TakingOff = "TakingOff",
  TimeEstimate = "TimeEstimate",
  None = "None",
  LandedInDock = "LandedInDock",
  Loading = "Loading",
  SubjectTracking = "SubjectTracking",
  FollowingSubject = "FollowingSubject",
  MissionActive = "MissionActive",
  FlyingToPoint = "FlyingToPoint",
}
